import { render, staticRenderFns } from "./NewEventTemplate.vue?vue&type=template&id=fc05a3ae&scoped=true&"
import script from "./NewEventTemplate.vue?vue&type=script&lang=js&"
export * from "./NewEventTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc05a3ae",
  null
  
)

export default component.exports